import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getAuthHeader from "../../utils/getAuthHeader";
import { latinToUTF8 } from "../../utils/latinToUTF8";
import styles from "./PdfDownload.module.css";

const PdfDownload = ({ filename }) => {
  const displayFilename = latinToUTF8(filename);

  const handleDownload = async () => {
    try {
      const response = await fetch(`/api/pdf/downloadPdf/${filename}`, {
        headers: getAuthHeader(),
      });
      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(new Blob([blob]));
      link.download = displayFilename;
      link.click();
    } catch (error) {
      console.error("Error downloading pdf: " + error);
    }
  };

  return (
    <div className={styles.pdfDownloadContainer}>
      <p className={styles.pdfDocumentTitle}>
        {displayFilename.length > 15
          ? displayFilename.substring(0, 15) + "..."
          : displayFilename}
      </p>
      <button onClick={handleDownload} className={styles.downloadButton}>
        <div className={styles.downloadButtonText}>PREUZMI</div>
        <FontAwesomeIcon icon={faDownload} style={{ color: "#ffffff" }} />
      </button>
    </div>
  );
};

export default PdfDownload;
